"use client";

import { ReactNode } from "react";

interface VideoCarouselCardClientWrapperProps {
  children: ReactNode;
  onClick: () => void;
}

export default function VideoCarouselCardClientWrapper({
  children,
  onClick,
}: VideoCarouselCardClientWrapperProps) {
  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      style={{ cursor: 'pointer' }}
    >
      {children}
    </div>
  );
} 